import React from 'react';
import { useLanguage } from '../translations/LanguageContext';
import { Card } from './ui/card';
import { MapPin, Phone, Mail, Clock, MessageCircle } from 'lucide-react';

const Contact = () => {
  const { t } = useLanguage();
  
  // Check if translations are loaded
  if (!t || !t.contact) {
    return <div className="min-h-screen flex items-center justify-center">Loading translations...</div>;
  }
  
  const address = "Plaza del Bulevar, 13, 29649 La Cala de Mijas, Málaga, Spain";
  const encodedAddress = encodeURIComponent(address);
  // Coordinates for precise pin placement next to Tupurna foot clinic
  const coordinates = "36.5127,-4.6317";

  return (
    <div className="min-h-screen pt-24 pb-20 px-4">
      <div className="container max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h1 className="heading-1 mb-4">{t.contact.title}</h1>
          <p className="body-large text-secondary max-w-2xl mx-auto">
            {t.contact.subtitle}
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 mb-12">
          {/* Contact Information */}
          <Card className="product-card p-8">
            <h2 className="heading-3 mb-6">{t.contact.getInTouch}</h2>
            
            <div className="space-y-6">
              <div className="flex items-start gap-4">
                <MapPin className="text-accent-primary flex-shrink-0" size={24} />
                <div>
                  <h3 className="body-medium font-semibold mb-1">{t.contact.address}</h3>
                  <p className="body-medium text-secondary">
                    Plaza del Bulevar, 13<br />
                    29649 La Cala de Mijas<br />
                    Málaga, Spain
                  </p>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Phone className="text-accent-primary flex-shrink-0" size={24} />
                <div>
                  <h3 className="body-medium font-semibold mb-1">{t.contact.phone}</h3>
                  <a href="tel:+34641654334" className="body-medium text-accent-text hover:text-accent-strong">+34 641 654 334
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <MessageCircle className="text-accent-primary flex-shrink-0" size={24} />
                <div>
                  <h3 className="body-medium font-semibold mb-1">{t.contact.whatsapp}</h3>
                  <a href="https://wa.me/34641654334" target="_blank" rel="noopener noreferrer" className="body-medium text-accent-text hover:text-accent-strong">https://wa.me/34641654334
                  </a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Mail className="text-accent-primary flex-shrink-0" size={24} />
                <div>
                  <h3 className="body-medium font-semibold mb-1">{t.contact.email}</h3>
                  <a href="mailto:acutranquil@gmail.com" className="body-medium text-accent-text hover:text-accent-strong">acutranquil@gmail.com</a>
                </div>
              </div>

              <div className="flex items-start gap-4">
                <Clock className="text-accent-primary flex-shrink-0" size={24} />
                <div>
                  <h3 className="body-medium font-semibold mb-1">{t.contact.officeHours}</h3>
                  <div className="body-medium text-secondary space-y-1">
                    <p><strong>{t.contact.hoursWeekday}</strong> {t.contact.hoursWeekdayTime}</p>
                    <p><strong>{t.contact.hoursWeekend}</strong> {t.contact.hoursWeekendTime}</p>
                  </div>
                </div>
              </div>
            </div>
          </Card>

          {/* Map */}
          <Card className="product-card p-0 overflow-hidden">
            <h2 className="heading-3 p-8 pb-4">{t.contact.mapTitle}</h2>
            <div className="w-full h-[500px]">
              <iframe
                title="Tranquil Acupuncture Location"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3205.8!2d-4.679360811043731!3d36.50563785124497!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMzbCsDMwJzIwLjMiTiA0wrA0MCc0NS43Ilc!5e0!3m2!1sen!2ses!4v1234567890!5m2!1sen!2ses"
                width="100%"
                height="100%"
                style={{ border: 0 }}
                allowFullScreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade">
              </iframe>
            </div>
          </Card>
        </div>
      </div>
    </div>
  );
};

export default Contact;
